import { useMutation } from "@tanstack/react-query";
import { useHospitalData } from "../contexts/HospitalDataProvider";
import { backendService } from "../services/backend.service";

type LogProductEventParams = { eventType: string; action: string; eventParams?: Record<string, unknown> };

export const useLogProductEvent = () => {
	const { chosenDepartment } = useHospitalData();

	return useMutation({
		mutationFn: ({ eventType, action, eventParams }: LogProductEventParams) =>
			backendService.logProductEvent({ eventType, action, departmentId: chosenDepartment.department_id, eventParams }),
	});
};
